/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @param fromDate 
     * @param toDate 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppDashboardParticipantDashboard(
fromDate?: string,
toDate?: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/dashboard/participant-dashboard',
            query: {
                'FromDate': fromDate,
                'ToDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
